var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"am-button",class:[
		`am-button--${_vm.theme}`,
		`am-button--${_vm.size}`,
		{
			'is-filled': _vm.filled,
			'is-borderless': _vm.borderless
		}
	],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('am-icon',{staticClass:"am-button__icon",attrs:{"name":_vm.icon,"dark":_vm.filled,"theme":_vm.theme,"size":"sm"}}),_c('am-text',{staticClass:"am-button__text",attrs:{"type":"button","dark":_vm.filled,"theme":_vm.theme}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }